import Link from 'next/link';
import {UserAvatar} from './kidsplaza-spring.desktop.user-avatar';
import {CustomerRoutes, Routes} from '@/config/routes';
import {useCustomerKicoins} from '@/framework/cart';
import {KiCoinIcon} from '@/_application/icons/ki-coin';

export function UserInfo() {
    const {data: customerKicoins} = useCustomerKicoins();
    return (
        <div className="relative flex items-center justify-between rounded-2xl bg-white text-sm shadow-md">
            <UserAvatar />

            <div className="h-9 w-px bg-KPZ_divider" />

            <Link
                href={`${Routes.customer}/${CustomerRoutes.amRewards}`}
                className="flex items-center gap-1 py-3 pl-1.5 pr-2.5">
                <KiCoinIcon className="h-8.5 w-8.5 shrink-0" />

                <div className="flex flex-col">
                    <p className="text-[12px] font-bold text-KPZ_text_1st">KiCoin</p>
                    <p className="inline-block max-w-12	overflow-hidden text-ellipsis whitespace-nowrap text-[14px] font-bold text-primary">
                        {customerKicoins?.customerKicoin?.balance ?? 0}
                    </p>
                </div>
            </Link>
        </div>
    );
}
